import React from 'react'
import { findDOMNode } from 'react-dom'
import NoTiles from 'helpers/map/NoTiles'
import ContextMenu from 'ContextMenu'
import { connect } from 'react-redux'
import MapComponents from 'components/MapComponents'
import { mapReadyAction } from 'actions/exportActions'
import style from './style'
import injectSheet from 'react-jss'
import isOverview from 'helpers/isOverview'
import { throttleUpdateMapLocationAction, updateMapZoomAction,
  addMapToStateAction, zoomToAllDevicesAction,
  updateMapLocationAction, updateMapTypeAction } from 'actions/mapActions'
import { updateCurrentEntityAction, checkOfflineLimitsAction } from 'actions/applicationActions'
import { BLANK, DEFAULT_SHAPE_OPTIONS, CONTEXT_MENU_OPTIONS } from 'helpers/globals'
import { addMarkupAction } from 'actions/markupActions'
import { updateUiAction } from 'actions/uiActions'
import showContextMenu from 'helpers/showContextMenu'
import eventHandler from 'helpers/map/eventHandler'
import ExportStatus from 'components/ExportStatus'
import onMobile from 'helpers/onMobile'

const mapStateToProps = state => {
  const { currentEntity, exports, exportType, map: { location, zoom, mapType }, currentProjectMetadata: { _id }, ui: { drawingWire } } = state

  return {
    location,
    zoom,
    _id,
    mapType,
    exportType,
    currentEntity,
    exporting: !EXPORT && !!exports.length,
    drawingWire
  }
}

class Map extends React.Component {
  disabledEvents = {}
  state = {
    dragging: false,
    mapOptions: {
      zoomControl: !EXPORT && !onMobile(),
      mapTypeControl: false,
      zoom: this.props.zoom,
      minZoom: 2,
      streetViewControl: false,
      tilt: 0,
      keyboardShortcuts: false,
      scaleControl: true,
      mapTypeId: this.props.mapType,
      center: this.props.location || { lat: 40.7493242889004, lng: -73.96888876455688 },
      fullscreenControl: false,
      rotateControl: false,
      gestureHandling: 'greedy',
      clickableIcons: false,
      styles: [
        {
          'featureType': 'poi.attraction',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'poi.business',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'poi.sports_complex',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        }
      ]
    }
  }

  addEventListeners({ map, contextMenu }) {
    map.addListener('center_changed', _ => !this.disabledEvents.centerChanged && !EXPORT && this.props.throttleUpdateMapLocationAction())
    map.addListener('zoom_changed', _ => !this.disabledEvents.zoomChanged && this.props.updateMapZoomAction(map.getZoom()))
    map.addListener('contextmenu', showContextMenu(contextMenu))

    map.addListener('click', _ => {
      if (this.props.currentEntity.type === 'map' || this.props.drawingWire) return
      this.props.updateCurrentEntityAction({ type: 'map' })
    })

    google.maps.event.addListener(contextMenu, 'menu_item_selected', eventHandler.bind(this))
    google.maps.event.addListener(map, 'dragstart', _ => this.setState({ dragging: true }))
    google.maps.event.addListener(map, 'dragend', _ => this.setState({ dragging: false }))
    google.maps.event.addListenerOnce(map, 'idle', _ => this.props.updateUiAction({ mapLoaded: true }))
  }

  componentDidMount() {
    const { state: { mapOptions }, props: { classes, updateMapTypeAction } } = this
    const map = new google.maps.Map(findDOMNode(this.refs.map), mapOptions)
    map.mapTypes.set(BLANK, new NoTiles())
    this.initDrawingManager(map)

    this.props.addMapToStateAction(map, this.refs.map)
    this.props.location || this.checkUsersLocation(map)

    const contextMenu = new ContextMenu(map, CONTEXT_MENU_OPTIONS(classes))
    this.contextMenu = contextMenu

    // set map type to roadmap if on mobile
    if (onMobile()) updateMapTypeAction('roadmap')

    this.map = map
    this.addEventListeners({ map, contextMenu })
    this.forceUpdate()
  }

  initDrawingManager = map => {
    this.drawingManager = new google.maps.drawing.DrawingManager({
      map,
      drawingControl: false,
      markerOptions: DEFAULT_SHAPE_OPTIONS,
      circleOptions: DEFAULT_SHAPE_OPTIONS,
      polygonOptions: DEFAULT_SHAPE_OPTIONS,
      polylineOptions: DEFAULT_SHAPE_OPTIONS,
      rectangleOptions: DEFAULT_SHAPE_OPTIONS
    })
    google.maps.event.addListener(this.drawingManager, 'overlaycomplete', e => {
      this.drawingManager.setDrawingMode(null)
      this.props.addMarkupAction(e.type, e.overlay)
    })
  }

  componentWillReceiveProps({ location, zoom, mapType }) {
    location && location !== this.props.location && !this.state.dragging && this.withoutListener('centerChanged', _ => this.map.setCenter(location))
    zoom && zoom !== this.map.getZoom() && this.withoutListener('zoomChanged', _ => this.map.setZoom(zoom))
    if (mapType !== this.props.mapType) {
      this.map.setMapTypeId(mapType)
    }
  }

  withoutListener = (eventName, fn) => {
    this.disabledEvents[eventName] = true
    fn()
    this.disabledEvents[eventName] = false
  }

  checkUsersLocation(map) {
    navigator.geolocation.getCurrentPosition(position => {
      const { coords: { latitude, longitude } } = position
      map.panTo({ lat: latitude, lng: longitude })
    })
  }

  mapClassName(classes) {
    if (EXPORT) return isOverview(this.props.exportType) || this.props.currentEntity.type !== 'camera' ? classes.overviewMap : classes.exportMap
    return onMobile() ? classes.mobileMap : classes.map
  }

  render() {
    const { map, drawingManager, contextMenu, props: { exportType, classes } } = this
    return (
      <div className={isOverview(exportType) ? classes.overviewMapContainer : classes.mapContainer} id='mapContainer'>
        <div className={this.mapClassName(classes)} ref='map' />
        {map && <MapComponents {...{ map, drawingManager, contextMenu, mapComponentRef: this.refs.map }} />}
        {!EXPORT && <ExportStatus />}
      </div>
    )
  }
}

export default connect(mapStateToProps, { updateCurrentEntityAction, updateMapZoomAction,
  addMapToStateAction, addMarkupAction, throttleUpdateMapLocationAction,
  zoomToAllDevicesAction, mapReadyAction, updateMapLocationAction,
  updateMapTypeAction, checkOfflineLimitsAction, updateUiAction })(injectSheet(style)(Map))



// WEBPACK FOOTER //
// ./src/components/Map/index.js